module.exports = __webpack_public_path__ + "apple-icon-114x114.3960d7bf.png";